import { Button } from "@engaging-tech/components"
import React from "react"

const ResendEmail = ({ t, sendEmail, setEmailResent }) => {
  const handleClick = () => {
    sendEmail()
    setEmailResent(true)
  }

  return (
    <Button variant="primary.0" height={36} px={4} onClick={handleClick}>
      {t ? t("thankyou.resend_btn", "") : "Send Results To My Email"}
    </Button>
  )
}

export default ResendEmail
